export class Brand {
  public brandId?: number;
  public brandName?: string;
  public hasSizeGroup?: boolean;

  public categories?: Array<any>

  public checked?: boolean;
}
